// axios.js
import Vue from 'vue'
import axios from 'axios'
import { foundryRequest } from '@/config/authConfig'
import { msalInstance } from '@/plugins/auth/msal-plugin'

const attachMsalInterceptors = (axiosInstance, scopes) => {
    axiosInstance.interceptors.request.use(async (config) => {
        const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];

        if (!account) return config;

        try {
            // Attempt silent token retrieval
            const response = await msalInstance.acquireTokenSilent({
                scopes: scopes,
                account: account
            });
            config.headers.Authorization = `Bearer ${response.accessToken}`;
        } catch (error) {
            console.warn('Silent token failed. User interaction required.', error);
            
            // Fallback to Redirect if silent fails (e.g. session expired)
            msalInstance.acquireTokenRedirect({ scopes: scopes, account: account });
        }
        return config;
    }, (error) => Promise.reject(error));

    axiosInstance.interceptors.response.use((response) => response, async (error) => {
        const originalRequest = error.config;

        // If 401 Unauthorized and we haven't retried yet
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            
            const account = msalInstance.getActiveAccount() || msalInstance.getAllAccounts()[0];
            if (!account) return Promise.reject(error);

            try {
                // Force token refresh
                const response = await msalInstance.acquireTokenSilent({
                    scopes: scopes,
                    account: account,
                    forceRefresh: true 
                });

                originalRequest.headers.Authorization = `Bearer ${response.accessToken}`;
                return axiosInstance(originalRequest); // Retry request

            } catch (refreshError) {
                console.error('Force token refresh failed. Redirecting to login.', refreshError);
                // Clear state and force redirect
                msalInstance.loginRedirect({ scopes: scopes });
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    });
};

export const http = axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    timeout: 240000, 
    headers: { 'Cache-Control': 'no-cache', "Content-Type": "application/json" }
});

attachMsalInterceptors(http, foundryRequest.scopes);

Vue.prototype.$http = http;
export default http;

export const createApi = ({ baseURL, authType = 'none', scopes = [], timeout = 240000 }) => {
    const instance = axios.create({ baseURL, timeout });
    if (authType === 'msal' && scopes.length > 0) {
        attachMsalInterceptors(instance, scopes);
    }
    return instance; 
};

// Exports
let skutopiaInstance = null;
export const initSkutopiaApi = (baseURL, scopes) => {
   skutopiaInstance =  createApi({ baseURL, authType: 'msal', scopes });
   return skutopiaInstance;
}
export const $skutopia = () => skutopiaInstance || console.warn("Skutopia called before initSkutopiaApi()");
let odbInstance = null;
export const initODBApi = (baseURL, scopes) => {
    odbInstance = createApi({ baseURL, authType: 'msal', scopes });
}
export const $odb = () => odbInstance || console.warn("OneDB called before initSkutopiaApi()");
let oculisInstance = null;
export const initOculisApi = (baseURL, scopes) => {
    oculisInstance = createApi({ baseURL, authType: 'msal', scopes });
}
export const $oculis = () => oculisInstance || console.warn("Oculis called before initSkutopiaApi()");